import React from "react";
import { Button } from "appStyles";
import { css } from "react-emotion";
import FileCopyIcon from "@material-ui/icons/FileCopy";
const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;
const spanStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #858585;
  display: inline-block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  text-align: center;
  width: 80%;
`;
const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-bottom: 35px;
`;
const textAreaStyle = css`
  font-size: 0.9375rem;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 0.5px solid #979797;
  position: relative;
  background-color: rgba(255, 255, 255, 0.3);
  transition: 0.3s all;
  :hover {
    /* background-color: rgba(255, 255, 255, 0.45); */
    /* box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);  */
  }
`;

class CopyClipboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      copySuccess: "",
    };
  }

  copyToClipboard = (e) => {
    this.textArea.select();
    document.execCommand("copy");
    e.target.focus();
    this.setState({ copySuccess: "Copied!" });
  };

  render() {
    return (
      <div
        style={{
          marginLeft: "10px",
        }}
      >
        <form style={{ display: "inline-block", width: "550px" }}>
          <textarea
            rows="1"
            style={{
              display: "inline-block",
              resize: "none",
              padding: "10px",
              width: "400px",
              float: "left",
            }}
            ref={(textarea) => (this.textArea = textarea)}
            defaultValue={this.props.text}
            className={textAreaStyle}
          />
          {document.queryCommandSupported("copy") && (
            <Button
              style={{
                display: "inline-flex",
                alignItems: "center",
                margin: "0px",
                textAlign: "center",
                marginLeft: "20px",
                height: "42px",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
              className={mdcButton}
              onClick={this.copyToClipboard}
            >
              <FileCopyIcon style={{ marginRight: "5px" }}></FileCopyIcon>
              Copy Link
            </Button>
          )}
        </form>
        {/* <span className={spanStyle} style={{display:"inline-block"}}>{this.state.copySuccess}</span> */}
      </div>
    );
  }
}

export default CopyClipboard;
